import { Box, Button, Grid, Typography } from '@mui/material'
import React from 'react'

import { Link as RouterLink } from 'react-router-dom'
import dealershipBrandsDict from '../../../constants/dealershipBrands'

const DealershipView = ({ data, refetch }) => {
  return (
    <Grid container rowGap={1} sx={{ p: 2 }}>
      <Grid item xs={12}>
        <Box display='flex' justifyContent='flex-end'>
          <Button
            variant='outlined'
            LinkComponent={RouterLink}
            to={`/admin/dealerships/edit/${data._id}`}
          >
            Edit
          </Button>
        </Box>
      </Grid>

      <Grid item xs={12} sm={12} md={4}>
        <Typography variant='subtitle1'>Dealership ID</Typography>
        <Typography variant='body2' color='textSecondary'>
          {data._id}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Typography variant='subtitle1'>Name</Typography>
        <Typography variant='body2' color='textSecondary'>
          {data.name}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Typography variant='subtitle1'>Brand</Typography>
        <Typography variant='body2' color='textSecondary'>
          {dealershipBrandsDict[data.brand] || data.brand}
        </Typography>
      </Grid>
      {Boolean(data.registration || data.registrationLegacy) && (
        <Grid item xs={12}>
          <Typography variant='subtitle1'>Registration Number</Typography>
          <Typography variant='body2' color='textSecondary'>
            {data.registration
              ? `${data.registration}${
                  data.registrationLegacy ? ` (${data.registrationLegacy})` : ''
                }`
              : data.registrationLegacy}
          </Typography>
        </Grid>
      )}
      {data.address && (
        <Grid item xs={12}>
          <Typography variant='subtitle1'>Address</Typography>
          <Typography variant='body2' color='textSecondary'>
            {data.address}
          </Typography>
        </Grid>
      )}
      {data.state && (
        <Grid item xs={12}>
          <Typography variant='subtitle1'>State</Typography>
          <Typography variant='body2' color='textSecondary'>
            {data.state}
          </Typography>
        </Grid>
      )}
      {Array.isArray(data.phone) && data.phone?.length > 0 && (
        <Grid item xs={12} md={6}>
          <Typography variant='subtitle1'>Tel.</Typography>
          <Typography variant='body2' color='textSecondary'>
            {data.phone.join(' / ')}
          </Typography>
        </Grid>
      )}
      {Array.isArray(data.fax) && data.fax?.length > 0 && (
        <Grid item xs={12} md={6}>
          <Typography variant='subtitle1'>Fax</Typography>
          <Typography variant='body2' color='textSecondary'>
            {data.fax.join(' / ')}
          </Typography>
        </Grid>
      )}
    </Grid>
  )
}

export default DealershipView
